<template>
  <div v-if="contents.length > 0" class="live live01">
    <div class="inner">
      <Title>
        <template #title>
          プレゼントキーワード付き企業LIVE
        </template>
      </Title>
      <div class="description">
        <p>美と健康をテーマに子育て応援企業やメーカーが約40社集合！配信中に発表されるキーワードを５つ集めて抽選会に応募しよう！<br><font color="red">※プレゼント抽選会は終了しました。</font></p>
      </div>
      <div>
        <div class="live-programs"
        >
          <LiveProgram10tsuruha
            v-for="(program, idx) in contents"
            :key="idx"
            :program="program"
            liveType="company"
            :month="month"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram10tsuruha from '@/components/molecules/202010tsuruha/LiveProgram.vue'

export default {
  props: {
    contents: {},
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram10tsuruha
  }
}
</script>

<style lang="sass" scoped>
.live01
  padding: 20px 0 25px
</style>